export const endpoints = {
  searchCompanyReports: 'companyReport/search',
  deleteCompanyReportItem: 'companyReport'
};
